import {
    SPORTSMEN_PATCH_FAILURE,
    SPORTSMEN_PATCH_REQUEST,
    SPORTSMEN_PATCH_SUCCESS,
} from 'actions';

const initialState = {
    patching: false,
    hasErrors: false,
};

export const sportsmanPatchReducer = (state = initialState, action) => {
    const {type, sportsman} = action;
    switch (type) {
        case SPORTSMEN_PATCH_SUCCESS: {return {
            ...initialState,
            sportsman,
        }}

        case SPORTSMEN_PATCH_REQUEST: {return {
            ...initialState,
            patching: true,
        }}

        case SPORTSMEN_PATCH_FAILURE: {return {
            ...initialState,
            hasErrors: true,
        }}

        default: { return state }
    }
};
